<div class="side-bar">
  <ul>
    <!-- <li>
      <div class="profile_info">
        <div class="circle big-profile">
          <img src="{{ data?.image }}" (error)="errorHandler($event)" />
        </div>
        <div class="profile-details">
          <div>
            <h5 class="text-capitalize">{{ data?.name }}</h5>
          </div>
          <button
            class="btn btn-link"
            [routerLink]="['/my-account/edit-profile']"
          >
          {{"SIDEBAR.EDIT_PROFILE" | translate}}
          </button>
        </div>
      </div>
    </li> -->
    <li>
      <a
        routerLinkActive="active"
        (click)="open()"
        [routerLink]="['/my-account/profile']"
      >
        <span class="material-icons">person</span>
        <div>
          {{ "SIDEBAR.MY_PROFILE" | translate }}
          <span class="sub_menu">{{
            "SIDEBAR.USER_PROFILE_DETAIL" | translate
          }}</span>
        </div>
        <span class="right_arrow material-icons">keyboard_arrow_right</span>
      </a>
    </li>
    <!-- <li>
      <a [routerLink]="['/my-account/edit-profile']"> Edit Profile </a>
    </li> -->
    <li>
      <a
        routerLinkActive="active"
        (click)="open()"
        [routerLink]="['/my-account/my-subscription']"
      >
        <span class="material-icons">flag</span>
        <div>
          {{ "SIDEBAR.SUBSCRIPTION" | translate }}
          <span class="sub_menu"> {{ "SIDEBAR.UPDATE_PLAN" | translate }}</span>
        </div>
        <span class="right_arrow material-icons">keyboard_arrow_right</span>
      </a>
    </li>
    <li *ngIf="!socialMediaUser">
      <a
        routerLinkActive="active"
        (click)="open()"
        [routerLink]="['/my-account/change-password']"
      >
        <span class="material-icons">lock_outline</span>
        <div>
          {{ "SIDEBAR.CHANGE_PASSWORD" | translate }}
          <span class="sub_menu">{{
            "SIDEBAR.ADD_STRONG_PASSWORD" | translate
          }}</span>
        </div>
        <span class="right_arrow material-icons">keyboard_arrow_right</span>
      </a>
    </li>
  </ul>
</div>
